import { render, staticRenderFns } from "./wallet-history.vue?vue&type=template&id=32b61670"
import script from "./wallet-history.vue?vue&type=script&lang=js"
export * from "./wallet-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports